import {
  MenuList,
  MenuListItemType,
  MenuListItemVariant,
  WfIconMiscWorkoutProfilesAlertsRegular,
  WfIconMiscWorkoutProfilesPagesRegular,
} from "@WahooFitness/redesignr";
import { t } from "@lingui/macro";
import { useMemo } from "react";
import { WSMWorkoutProfile } from "@WahooFitness/wsm-native/dist/esm/types/workout_profile";
import { ReactRouterLinkWrapper } from "@/components/MenuList/ReactRouterLinkWrapper";
import { useTheme } from "@mui/material";

const ProfilePreferencesSection = ({
  profile,
  workoutTypeName,
}: {
  profile?: WSMWorkoutProfile;
  workoutTypeName: string;
}) => {
  const { palette } = useTheme();
  const sectionItems = useMemo(
    () =>
      [
        {
          id: "workoutPages",
          content: t`Workout pages`,
          variant: MenuListItemVariant.CardLink,
          linkLocation: `/workout-profiles/${profile?.external_id}/workout-pages`,
          icon: <WfIconMiscWorkoutProfilesPagesRegular />,
          hasDivider: false,
          linkComponent: ReactRouterLinkWrapper,
        },
        {
          id: "audioAnnouncements",
          content: t`Alerts`,
          variant: MenuListItemVariant.CardLink,
          linkLocation: `/workout-profiles/${profile?.external_id}/alerts`,
          hasDivider: false,
          icon: <WfIconMiscWorkoutProfilesAlertsRegular />,
          linkComponent: ReactRouterLinkWrapper,
        },
      ] as MenuListItemType[],
    [profile?.external_id]
  );

  return (
    <MenuList
      title={`${workoutTypeName} preferences`}
      listItems={sectionItems}
      variant="outlined"
      paperProps={{
        sx: {
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignContent: "flex-start",
          gap: 1,
          border: "none",
          background: palette.background.default,
        },
      }}
    />
  );
};

export default ProfilePreferencesSection;
